import './../css/_app.scss';
import 'aos/dist/aos.css';
import carousel from "./carousel";
import benefits from "./benefits";
import modal from "./modal";
import hamburger from './hamburger';
import tabs from './tabs';
import scroll from './scroll';
import AOS from 'aos';

export default class App {
    initCore() {
        AOS.init({
            startEvent: 'load',
            delay: 100
        });
        hamburger.init();
        carousel.init();
        scroll.init();
        benefits.init();
        tabs.init();
        modal.init();
        console.log('core');
    }
}

function LoadApp() {
    const app = new App();
    app.initCore();
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', LoadApp);
} else {
	LoadApp();
}